import { render, staticRenderFns } from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue?vue&type=template&id=a6fc89ec"
import script from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports